import InlineComponent from './inlineComponent.jsx';
import HashPropertyActions from '../../../components/hash/HashPropertyActions.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = HashPropertyActions;
  }
};
